<template lang="pug">
  .main
    .flexRight
      //- 抄表数据统计
      .info-box(v-for="item in statDatas")
        .desc-info {{item.desc}}
        .import-info {{item.num}}
        .import-info_percent(v-if="item.percent") {{item.percent.desc}}&nbsp;&nbsp;&nbsp;{{item.percent.num}}%
    DataTablePageNew(
      ref="dataQuery"
      mainColumn=""
      longColumn=""
      title=""
      :resource="resource"
      :operation="operation"
      :operationWidth=100
      :tableFullList="tableFullList"
      :tableInitList="tableInitList"
      :filterFullList="filterFullList"
      :filterInitList="filterInitList"
      :columns="columns"
      @getData="renderData")
</template>

<script>
import DataTablePageNew from '@/containers/DataTablePage/defined'
import columns from './waterColumns.js'
import { URL } from '@/utils/common'
import { expire } from '@/utils/auth'
export default {
  name: 'DataQuery',
  components: {
    DataTablePageNew
  },
  data () {
    return {
      resource: '/meterPayload/history/readingSearch',
      allNum: 0, // 总数
      operation: [{
        label: '查看历史数据',
        icon: 'meterRecords',
        tooltip: true,
        func ({funcProps}) {
          const { data } = funcProps
          this.$router.push({
            path: `/telnetReading/dataQueryHistory/${data.counterId}`
          })
        }
      }],
      tableInitList: ['hno', 'hname', 'phone', 'mobile', 'addr', 'wave', 'lnum', 'lquanty', 'num', 'quanty', 'counterCode', 'areaPathName', 'cost'],
      tableFullList: ['hno', 'hname', 'phone', 'mobile', 'addr', 'wave', 'lnum', 'lquanty', 'num', 'quanty', 'counterCode', 'areaPathName', 'cost'],
      filterInitList: ['areaId', 'result', 'time'],
      filterFullList: ['areaId', 'result', 'time'],
      columns: {
        ...columns,
        areaId: {
          label: '计量器区域',
          relation: 'areaId',
          type: 'select',
          width: 150,
          filter: {
            type: 'cascader',
            width: 120,
            onlySelectLeaf: false,
            rules: [{ type: 'required', message: '请选择对应的区域' }]
          }
        },
        type: {
          label: '数据类型',
          type: 'select',
          filter: {
            type: 'select'
          },
          options: [{
            label: '点抄', value: 'click_reading'
          }, {
            label: '定抄', value: 'timing_reading'
          }]
        },
        result: {
          label: '执行结果',
          type: 'select',
          width: 100,
          filter: {
            type: 'select'
          },
          options: [{
            label: '成功',
            value: 'success'
          }, {
            label: '失败',
            value: 'failed'
          }]
        },
        image: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${URL}/${data}" style="height:24px"></img>`
          }
        }
      },
      statDatas: [{
        desc: '当前抄表总数',
        num: 0
      }]
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    renderData (data) {
      if (data) {
        const {allNum} = data
        const allData = {...this.statDatas[0], num: allNum}
        this.statDatas = [allData]
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.main
  padding: 0
  .main
    padding: 0 20px 20px
.flexRight
  display: flex
  padding: 0 20px
  .info-box
    background: #fff
    border-radius: 5px
    box-shadow: 0px 1px 2px #ddd
    padding: 5px 20px
    margin-right: 10px
    margin-top: 10px
    min-width: 200px
    line-height: 30px
    .desc-info
      color: #8391a5
    .import-info
      font-size: 24px
    .import-info_percent
      border-top: 1px dotted #ddd
      text-align: right
</style>


// WEBPACK FOOTER //
// DataQuery.vue?711ea164